// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__SzXIU","code":"notFound_code__IPGUj","text":"notFound_text__QXTMK","button":"notFound_button__Z6NaR"};